import { Box, Card, CardContent, Divider, Typography } from "@mui/material";
import AIReviewedChip from "./AIReviewedChip";
import DataSourceIcon from "../../Components/DataSourcesPanel";

const RecentNewsCard = ({
  news,
  entityId,
  AiSectionFeedback,

  // NEW (for backend feedback integration)
  requestId,
  uiSectionKey = "recent_news",
  userEmail,
}) => {
  return (
    <Box sx={{ flex: 1, minWidth: 0 }}>
      <Card
        sx={{
          borderRadius: "0.5rem",
          border: "none",
          boxShadow: "0 10px 25px rgba(15, 23, 42, 0.08)",
          overflow: "hidden",
          bgcolor: "#ffffff",
          height: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            bgcolor: "#003366",
            color: "#ffffff",
            p: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 1,
          }}
        >
          {/* HEADER */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 700,
                fontSize: "1.125rem",
                color: "#ffffff",

                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              Recent News
              <AIReviewedChip mode="dark" />
              <DataSourceIcon mode="dark" sources={["Web Search"]} />
            </Typography>
          </Box>

          <AiSectionFeedback
            sectionName="EntityProfile - Recent News (AI-reviewed)"
            entityId={entityId}
            variant="dark"
            requestId={requestId}
            uiSectionKey={uiSectionKey}
            userEmail={userEmail}
          />
        </Box>

        {/* CONTENT */}
        <CardContent sx={{ p: 3 }}>
          {(news || []).map((n, idx) => (
            <Box key={`${n.headline}-${idx}`}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "flex-start",
                  justifyContent: "space-between",
                  gap: 1,
                }}
              >
                <Box>
                  <Typography
                    sx={{ fontWeight: 600, fontSize: "0.85rem", mb: 0.3 }}
                  >
                    {n.headline}
                  </Typography>
                  <Typography
                    variant="caption"
                    sx={{ display: "block", mb: 0.3, color: "#6b7280" }}
                  >
                    {n.date} — {n.source}
                  </Typography>
                </Box>
              </Box>

              <Typography sx={{ fontSize: "0.8rem" }}>{n.impact}</Typography>

              <Divider sx={{ my: 1.2 }} />
            </Box>
          ))}
        </CardContent>
      </Card>
    </Box>
  );
};

export default RecentNewsCard;
